import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'rt-tag',
  shadow: true,
  styleUrl: 'tag.scss',
})
export class TagComponent {
  @Prop() content = '';

  render() {
    return <span>{this.content}</span>;
  }
}
